import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const ResidencyPermitCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca persona - Registrazione Permesso di soggiorno',
    path: '/sportello/rilascioPDS',
  },
];
